import { toastManager } from '@insurancemenu/imenu-components-lib/dist/components/Toast/toastManager';
import { ToastColorTypes } from '@insurancemenu/imenu-components-lib/dist/types';
import { generateFilesForAutoRenew } from 'api/operations/biReportService';
import { SendOutEmailsModalStore } from 'store/general/sendOutEmailsModalStore';
import { getRootStoreInstance } from 'store/rootStore';

interface GenerateFilesForAutoRenewModalDelegateParams {
  getEffectiveDate: () => string;
}

export class GenerateFilesForAutoRenewModalDelegate extends SendOutEmailsModalStore {
  private _rootStore = getRootStoreInstance();
  constructor({ getEffectiveDate }: GenerateFilesForAutoRenewModalDelegateParams) {
    super({
      onSubmit: async (recipients: string[]): Promise<void> => {
        await generateFilesForAutoRenew(this._rootStore.userStore.sponsorId, getEffectiveDate(), recipients);
        toastManager.addToast(
          'File generation was successfully requested, please check your email soon!',
          ToastColorTypes.SUCCESS,
        );
      },
    });
  }
}
